import { useTranslation } from 'react-i18next'

import Text from '../../../Text'

import * as styles from './BirdviewChartCatalogEmpty.module.css'

function BirdviewChartCatalogEmpty({ search }) {
  const { t } = useTranslation()

  return (
    <div className={styles.empty}>
      <Text>{t('DashboardBirdview.ChartCatalogNoResultsKey', { search })}</Text>
      <Text isSecondary>
        {t('DashboardBirdview.ChartCatalogNoResultsHintKey')}
      </Text>
    </div>
  )
}

export default BirdviewChartCatalogEmpty
